import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.div`
  position: relative;
  border: solid 1px ${lightGrey2Color.hex()};
  border-radius: 0.25rem;
  background: white;
  margin-top: 1rem;
`;
